import { useFormContext } from 'react-hook-form';

import type { ConnectedAppFormSchema } from '../schemas';

export const useConnectedAppFormContext = () => {
  const context = useFormContext<ConnectedAppFormSchema>();

  return context;
};
